import React, { ReactElement, useState, useEffect } from 'react'

import { LoginModal } from '@components/LoginModal'
import { useUserAuth } from '@hooks/userAuthProvider/provider'
import { useSettings } from '@queries/settings'

interface ProtectedRouteProps {
  children: ReactElement
}

const ProtectedRoute = ({ children }: ProtectedRouteProps): ReactElement => {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false)
  const { isAuthenticated, isInitializing, restoreSession } = useUserAuth()
  const [{ logo }] = useSettings()

  useEffect(() => {
    restoreSession()
  }, [restoreSession])

  useEffect(() => {
    if (!isInitializing && !isAuthenticated) {
      setIsLoginModalOpen(true)
    } else if (isAuthenticated) {
      setIsLoginModalOpen(false)
    }
  }, [isAuthenticated, isInitializing])

  /* istanbul ignore next */
  const handleModalClose = () => {
    if (!isAuthenticated) {
      if (logo?.redirectionUrl && !localStorage.getItem('isLoggedIn')) {
        window.location.href = logo.redirectionUrl
        return
      }
      setIsLoginModalOpen(true)
    } else {
      setIsLoginModalOpen(false)
    }
  }

  return (
    <>
      {!isInitializing && <LoginModal isOpen={isLoginModalOpen} onClose={handleModalClose} />}
      {isAuthenticated ? children : <div className="protected-content-placeholder"></div>}
    </>
  )
}

export default ProtectedRoute
